import { z } from 'zod';
import { VaultCategory } from '../enums.js';
export const createVaultInput = z.object({
    label: z.string().min(1).max(200),
    category: z.nativeEnum(VaultCategory),
    username: z.string().max(200).optional().nullable(),
    // Arriva in chiaro e il server lo cifra. Il tetto è alto apposta: qui dentro
    // non finiscono solo password, ma anche token OAuth e chiavi SSH private, che
    // superano tranquillamente i duemila caratteri (il refresh token di GoDeal ne
    // vale 2.383, una chiave ed25519 ancora di più).
    password: z.string().min(1).max(20000),
    url: z.string().max(500).optional().nullable(),
    notes: z.string().max(5000).optional().nullable(),
    ownerId: z.string().optional().nullable(),
    expiresAt: z.string().datetime().optional().nullable(),
    allowedRoleIds: z.array(z.string()).default([]),
});
export const updateVaultInput = createVaultInput.partial();
export const revealVaultInput = z.object({
    password: z.string().min(1), // password utente per conferma
});
export const vaultEntryDTO = z.object({
    id: z.string(),
    label: z.string(),
    category: z.nativeEnum(VaultCategory),
    username: z.string().nullable(),
    url: z.string().nullable(),
    owner: z.object({ id: z.string(), firstName: z.string(), lastName: z.string() }).nullable(),
    allowedRoleIds: z.array(z.string()),
    expiresAt: z.string().nullable(),
    lastAccessAt: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
//# sourceMappingURL=vault.js.map